module.exports = __webpack_public_path__ + "img/grapes.18ab55d2.jpg";